import { render, staticRenderFns } from "./WebsiteTransportInfoList.vue?vue&type=template&id=74484515&scoped=true&"
import script from "./WebsiteTransportInfoList.vue?vue&type=script&lang=js&"
export * from "./WebsiteTransportInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74484515",
  null
  
)

export default component.exports